<div class="contacts">
  <p class="m-0">{{ _translateService.Keys.COMMON_CONTACT_US | translate }}:</p>
  <div>
    <a [href]="'mailto:' + supportEmail + '?subject=' + (user?.verificationInfo?.insuredName || '')">
      {{ supportEmail }}
    </a>
  </div>
</div>
